export type GeographicEntityKey = 'areaClusters' | 'geographicRegions' | 'provinces' | 'towns'

export type GeographicEntityConfig = {
  key: GeographicEntityKey
  title: string
  singular: string
  basePath: string
  apiPath: string
  archivedPath: string
  nameField: string
  nameLabel: string
  columns: Record<string, { name: string; withSort?: boolean; maxWidth?: string }>
}

export const geographicEntities: Record<GeographicEntityKey, GeographicEntityConfig> = {
  areaClusters: {
    key: 'areaClusters',
    title: 'Area Clusters',
    singular: 'Area Cluster',
    basePath: '/organization/area-clusters',
    apiPath: '/organization/area-clusters',
    archivedPath: '/organization/archived/area-clusters',
    nameField: 'name',
    nameLabel: 'Name',
    columns: {
      code: { name: 'Code', withSort: true, maxWidth: '140px' },
      name: { name: 'Name', withSort: true, maxWidth: '240px' },
      active: { name: 'Status', withSort: true },
      updated_at: { name: 'Updated At', withSort: true, maxWidth: '150px' },
    },
  },
  geographicRegions: {
    key: 'geographicRegions',
    title: 'PH Regions',
    singular: 'PH Region',
    basePath: '/organization/geographic-regions',
    apiPath: '/organization/geographic-regions',
    archivedPath: '/organization/archived/geographic-regions',
    nameField: 'name',
    nameLabel: 'Region Name',
    columns: {
      code: { name: 'Code', withSort: true, maxWidth: '140px' },
      name: { name: 'Name', withSort: true, maxWidth: '220px' },
      area_cluster_name: { name: 'Area Cluster', withSort: false, maxWidth: '180px' },
      active: { name: 'Status', withSort: true },
      updated_at: { name: 'Updated At', withSort: true, maxWidth: '150px' },
    },
  },
  provinces: {
    key: 'provinces',
    title: 'Provinces',
    singular: 'Province',
    basePath: '/organization/provinces',
    apiPath: '/organization/provinces',
    archivedPath: '/organization/archived/provinces',
    nameField: 'province_name',
    nameLabel: 'Province Name',
    columns: {
      code: { name: 'Code', withSort: true, maxWidth: '140px' },
      province_name: { name: 'Province', withSort: true, maxWidth: '200px' },
      area_cluster_name: { name: 'Area Cluster', withSort: false, maxWidth: '160px' },
      region_name: { name: 'PH Region', withSort: false, maxWidth: '180px' },
      active: { name: 'Status', withSort: true },
      updated_at: { name: 'Updated At', withSort: true, maxWidth: '150px' },
    },
  },
  towns: {
    key: 'towns',
    title: 'Towns',
    singular: 'Town',
    basePath: '/organization/towns',
    apiPath: '/organization/towns',
    archivedPath: '/organization/archived/towns',
    nameField: 'town_name',
    nameLabel: 'Town Name',
    columns: {
      code: { name: 'Code', withSort: true, maxWidth: '140px' },
      town_name: { name: 'Town', withSort: true, maxWidth: '200px' },
      province_name: { name: 'Province', withSort: false, maxWidth: '180px' },
      active: { name: 'Status', withSort: true },
      updated_at: { name: 'Updated At', withSort: true, maxWidth: '150px' },
    },
  },
}
